import { SemanticRequestError } from '../requestError';
import { m } from '../../paraglide/messages';

/** The gateway statuses a free tool phrases for the customer. Every free tool
 *  goes through the same public lifecycle, so one status vocabulary covers them
 *  all: 400 bad input, 403 failed verification, 429 rate limited, 503 the tool
 *  is switched off or out of budget. */
type PublicToolStatus = 400 | 403 | 429 | 503;

const MESSAGES: Record<PublicToolStatus, () => string> = {
  400: m.phase2_fix_public_tool_bad_input,
  403: m.phase2_fix_public_tool_verification,
  429: m.phase2_fix_public_tool_rate_limited,
  503: m.phase2_fix_public_tool_unavailable,
};

const isPublicToolStatus = (status: number | undefined): status is PublicToolStatus =>
  status !== undefined && status in MESSAGES;

/** The line a free tool shows for a failed request. A tool with its own wording
 *  for one status, such as a handle hint on 400, passes it as an override. */
export const publicToolError = (
  error: unknown,
  overrides: Partial<Record<PublicToolStatus, string>> = {},
): string => {
  const status = error instanceof SemanticRequestError ? error.status : undefined;
  if (!isPublicToolStatus(status)) return m.phase2_fix_public_tool_failed();
  return overrides[status] ?? MESSAGES[status]();
};
